import Vue from 'vue'

interface IEventBus {
  $on(eventName: string, payload?: any): void
  $emit(eventName: string, payload?: any): void
}

const EventBus = new Vue()

export { EventBus, IEventBus }
